/* vc-home-newsletter.js — newsletter sign-up.

   The form is Shopify's own customer form and posts normally; Omnisend's
   Shopify integration collects the subscriber server-side. This only catches a
   malformed address before the round trip and shows the message inline, so the
   page never navigates away just to report a typo.

   Loaded with defer. */
(function () {
  'use strict';

  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function setup(form) {
    if (form.__vcNews) return;
    form.__vcNews = true;

    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector('[data-vch-news-msg]');
    var invalid = form.getAttribute('data-invalid') || 'Please enter a valid email address.';
    if (!input) return;

    function say(text) {
      if (!msg) return;
      msg.textContent = text;
      if (text) {
        msg.setAttribute('data-state', 'error');
        msg.setAttribute('role', 'alert');
      } else {
        msg.removeAttribute('data-state');
        msg.setAttribute('role', 'status');
      }
    }

    form.addEventListener('submit', function (e) {
      var email = String(input.value || '').trim();
      if (!RE.test(email)) {
        e.preventDefault();
        say(invalid);
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      say('');
    });

    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true' && RE.test(input.value.trim())) {
        input.removeAttribute('aria-invalid');
        say('');
      }
    });
  }

  function initAll(r) {
    (r || document).querySelectorAll('[data-vch-newsletter]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
